import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { CalendarModuleRoutingModule } from './calendar-module-routing.module';
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'primeng/api';
import { ImportsPrimeModule } from 'src/app/_material/primeng.module';
import { SharedComponentsModule } from '../../shared/shared-components/shared-components.module';
import { CalendarComponent } from '../components/calendar/calendar.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import { NgSelectModule } from '@ng-select/ng-select';
// import { TooltipModule } from 'primeng/tooltip';


@NgModule({
  declarations: [
    CalendarComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ImportsPrimeModule,
    DatePipe,
    SharedModule,
    SharedComponentsModule,
    CalendarModuleRoutingModule,
    FullCalendarModule,
    NgSelectModule
    // TooltipModule 
  ]
})
export class CalendarModuleModule { }
